import React from 'react';

import { Tab, TabsContainer } from './Tabs.styles';

const Tabs = ({ activeTab, onTabChange }) => {
  return (
    <TabsContainer>
      <Tab $active={activeTab === 'myLeads'} onClick={() => onTabChange('myLeads')}>
        My Leads
      </Tab>
      <Tab $active={activeTab === 'mySales'} onClick={() => onTabChange('mySales')}>
        My Sales
      </Tab>
    </TabsContainer>
  );
};

export default Tabs;
